import CryptoJS from 'crypto-js'
import Papa from 'papaparse'
import Sqids from 'sqids'
import * as XLSX from 'xlsx'

// Function to extract URLs using regex
const extractUrls = (text: string): string[] => {
  const urlRegex = /(https?:\/\/[^\s]+)/g
  return text.match(urlRegex) || []
}

// Function to process CSV data
const processCSV = (csvText: string): string[] => {
  let urls: string[] = []
  const { data } = Papa.parse<string[]>(csvText, { skipEmptyLines: true })

  data.forEach((row) => {
    row.forEach((cell) => {
      urls.push(...extractUrls(cell))
    })
  })

  return [...new Set(urls)]
}

// Function to process Excel file
const processExcel = (buffer: Buffer): string[] => {
  let urls: string[] = []
  const workbook = XLSX.read(buffer, { type: 'buffer' })

  workbook.SheetNames.forEach((sheetName) => {
    const sheet = workbook.Sheets[sheetName]
    if (!sheet) return
    const sheetData = XLSX.utils.sheet_to_json<any>(sheet, { header: 1 })

    sheetData.forEach((row) => {
      row.forEach((cell: string) => {
        if (typeof cell === 'string') {
          urls.push(...extractUrls(cell))
        }
      })
    })
  })

  return [...new Set(urls)]
}

export const processSheetProducts = async (
  fileBuffer: Buffer,
  contentType: string
): Promise<string[] | undefined> => {
  if (!contentType || !fileBuffer) {
    return undefined
  }

  try {
    let urls: string[] = []

    if (contentType.includes('csv')) {
      urls = processCSV(fileBuffer.toString('utf-8'))
    } else if (
      contentType.includes('spreadsheetml') ||
      contentType.includes('ms-excel')
    ) {
      urls = processExcel(fileBuffer)
    } else {
      return undefined
    }

    return urls
  } catch (error) {
    return undefined
  }
}

export const generateBulkId = (urls: string[], userId?: string): string => {
  const squids = new Sqids()

  const urlsString = urls.join('')
  const hash = CryptoJS.MD5(`${userId || ''}:${urlsString}`).toString(
    CryptoJS.enc.Hex
  )
  const hashInDecimal = parseInt(hash.substring(0, 12), 16)
  let encoded = squids.encode([hashInDecimal])
  return encoded
}
